export default __webpack_public_path__ + "static/vista-sacada-mar-a29a633c22f27d68f005ded6015ed9da.webp";